import { ComputerProperyFieldMap } from '@modules/asset/helpers/property-fields/computer-property-field-map'
import { computerSystemComponentFieldMap } from '@modules/asset/helpers/component-fields/computer-system-component-field-map'
import { osComponentFieldMap } from '@modules/asset/helpers/component-fields/os-component-field-map'
import { biosComponentFieldMap } from '@modules/asset/helpers/component-fields/bios-component-field-map'
import { ramComponentFieldMap } from '@modules/asset/helpers/component-fields/ram-component-field-map'
import { processorComponentFieldMap } from '@modules/asset/helpers/component-fields/processor-component-field-map'
import { networkAdapterComponentFieldMap } from '@modules/asset/helpers/component-fields/network-adapter-component-field-map'
import { getRootPluaralTranslator } from '@utils/get-module-translator'
import { generateId } from '@utils/id'
const __tc = getRootPluaralTranslator()

const generateFieldParamName = (fields, preFix) => {
  return (fields || []).map((f) => ({
    ...f,
    paramName: `${preFix}.${f.paramName}`,
  }))
}
export const attributeFields = () => {
  return {
    fields: [
      {
        key: generateId(),
        paramName: 'locationId',
        name: __tc('location'),
        inputType: 'location',
      },
      {
        key: generateId(),
        paramName: 'assignedDepartmentId',
        name: __tc('department'),
        inputType: 'department',
      },
      {
        key: generateId(),
        paramName: 'productId',
        name: __tc('product'),
        inputType: 'product',
      },
      {
        key: generateId(),
        paramName: 'vendorId',
        name: __tc('vendor'),
        inputType: 'vendor',
      },
      {
        key: generateId(),
        paramName: 'companyId',
        name: __tc('company'),
        inputType: 'company',
      },
      ...generateFieldParamName(
        ComputerProperyFieldMap().computer_property_group.fields,
        'ComputerPropertyGroup'
      ),
      ...generateFieldParamName(
        computerSystemComponentFieldMap().computer_system_component.fields,
        'ComputerSystemComponent'
      ),
      ...generateFieldParamName(
        osComponentFieldMap().os_component.fields,
        'OsComponent'
      ),
      ...generateFieldParamName(
        biosComponentFieldMap().bios_component.fields,
        'BiosComponent'
      ),
      ...generateFieldParamName(
        ramComponentFieldMap().ram_component.fields,
        'RamComponent'
      ),
      ...generateFieldParamName(
        processorComponentFieldMap().processor_component.fields,
        'ProcessorComponent'
      ),
      ...generateFieldParamName(
        networkAdapterComponentFieldMap().network_adapter_component.fields,
        'NetworkAdapterComponent'
      ),
    ],
  }
}
